import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { LinkProps } from '@wix/thunderbolt-becky-types';
import {
  ICollapsibleTextMapperProps,
  CollapsibleTextDefinition,
} from '../CollapsibleText.types';
import { isAutoWidth } from '../CollapsibleText.utils';

export const props = withCompInfo<
  ICollapsibleTextMapperProps,
  CollapsibleTextDefinition,
  { link: LinkProps }
>()(
  ['compData', 'compProps', 'compStylableClass'],
  ({ compData, compProps, compStylableClass: className }, carmiData) => ({
    ...compData,
    ...compProps,
    ...carmiData,
    className,
  }),
);

export const css = withCompInfo()(
  ['compProps', 'compLayout', 'hasResponsiveLayout'],
  ({
    compProps: { maxLines, ellipsis, wrappingStyle, expandControlSpacing },
    compLayout,
    hasResponsiveLayout,
  }) => {
    // Width of CollapsibleText shouldn't be limited when is single line without wrapping and ellipsis
    const width = hasResponsiveLayout
      ? '100%'
      : isAutoWidth({ ellipsis, wrappingStyle })
      ? 'auto'
      : `${compLayout.width}px`;

    return {
      width,
      height: 'auto',
      '--max-lines': maxLines,
      '--expand-control-spacing': `${expandControlSpacing}px`,
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
});
